import { render, staticRenderFns } from "./page_list.vue?vue&type=template&id=6471d096&"
import script from "./page_list.vue?vue&type=script&lang=js&"
export * from "./page_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports